import { Component } from '@angular/core';

@Component({
  selector: 'cui-terms',
  imports: [],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
})
export class TermsComponent {}
